<template>
  <div class="row">
    <div class="col-lg-12 col-xl-12 mb-5">
      <dashboard-box :title="$t('menu.nap_transfer_campaigns')">
        <template v-slot:toolbar>
          <router-link
              to="/add-transfer-campaign"
              v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <b-button size="sm" @click="navigate"><i class="fa fa-plus mr-2"></i> Kampanya Ekle</b-button>
          </router-link>

        </template>
        <template v-slot:preview>

          <b-row>
            <b-col sm="12" lg="3" xl="3" class="mb-2">
              <b-input-group size="sm">
                <b-form-input placeholder="Arama yapın"></b-form-input>
                <b-input-group-append>
                  <b-button variant="primary"><i class="fa fa-search"></i> Ara</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>

          <data-table
              :items="table.items"
              :fields="report.fields"
              :paginate="report.paginate"
              page.sync="3"
              perPage.sync="10"
          ></data-table>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "NapTransferCampaigns",
  components: { DataTable, DashboardBox },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      alert(JSON.stringify(this.form));
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.name = "";
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  },
  data() {
    return {
      form : {

      },
      report : {
        paginate : {
          next_page_url: "#",
          path: "#",
          per_page: 15,
          prev_page_url: null,
          to: 15,
          total: 48,
          pageNumberProxy:1,
          current_page : 1,
          first_page_url: "http://127.0.0.1:8000/api/samples?page=1",
          from: 1,
          last_page: 20,
          last_page_url: "http://127.0.0.1:8000/api/samples?page=2",
          links: [
            {
              "url": null,
              "label": "&laquo; Öncekiler",
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=1",
              "label": 1,
              "active": true
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": 2,
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": "Sonrakiler &raquo;",
              "active": false
            }
          ],
        },
        fields: [
          {key: 'id', label: '#', sortable: true},
          {key: 'name', label: 'Kampanya Adı', sortable: true},
          {key: 'admin_desc', label: 'Admin Açıklaması', sortable: true},
          {key: 'point', label: 'Puan', sortable: true},
          {key: 'checkbox_status', label: 'Durum', sortable: true},
          {key: 'checkbox_live_status', label: 'Live', sortable: true},
          {key: 'max_participants', label: 'Maks. Katılım', sortable: true},
          {key: 'nap_transfer_action', label: 'İşlem', sortable: false},
        ],
      },
      table : {
        items : [
          {'id' : '3871304', 'name' : 'Flormar','admin_desc' : 'Flormar Oje Hediye', 'point' : '1000','max_participants' : '-', 'status' : 'Aktif'},
          {'id' : '3871303', 'name' : 'İlvi','admin_desc' : 'İlvi ayakkabı %10 indirim', 'point' : '2500','max_participants' : '-', 'status' : 'Aktif'},
          {'id' : '3871303', 'name' : 'Bilyoner Bilgi Yarışması','admin_desc' : 'Bilyoner bilgi yarışması', 'point' : '500','max_participants' : '-', 'status' : 'Aktif'},
        ],
      },
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t('general.project_2'), route: "alert" },
      { title: this.$t('menu.nap_transfer_campaigns') }
    ]);
  }
}
</script>

<style scoped>
</style>
